export default "__VITE_ASSET__db69cd16__"